// import styles
import "./AnaliticaAdmin.css";

// import pacchetti
import Select from "react-select";
import { useState, useEffect } from "react";

// Filtri per anno
const getYearFilters = (years) => {
  const yearOptions = years.map(year => ({
    value: year,
    label: year.toString()
  }));
  
  return [
    { value: null, label: "Tutti gli anni" },
    ...yearOptions
  ];
};

// Filtri per mese
const monthFilters = [
  { value: 0, label: "Tutti i mesi" },
  { value: 1, label: "Gennaio" },
  { value: 2, label: "Febbraio" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Aprile" },
  { value: 5, label: "Maggio" },
  { value: 6, label: "Giugno" },
  { value: 7, label: "Luglio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Settembre" },
  { value: 10, label: "Ottobre" },
  { value: 11, label: "Novembre" },
  { value: 12, label: "Dicembre" }
];

// Filtri per categoria
const getCategoriaFilters = (categorie) => {
  const categoriaOptions = categorie.map(categoria => ({
    value: categoria,
    label: categoria
  }));
  
  return [
    { value: "", label: "Tutte le categorie" },
    ...categoriaOptions,
    { value: "Non categorizzato", label: "Non categorizzato" }
  ];
};

export default function AnaliticaFilter({ 
  selectedYear, 
  onYearChange, 
  selectedMonth, 
  onMonthChange, 
  selectedCategoria, 
  onCategoriaChange, 
  searchTerm, 
  onSearch, 
  availableYears, 
  availableCategorie 
}) {
  const [yearOptions, setYearOptions] = useState([]);
  const [categoriaOptions, setCategoriaOptions] = useState([]);
  
  // Prepara le opzioni per gli anni
  useEffect(() => {
    if (availableYears) {
      setYearOptions(getYearFilters(availableYears));
    }
  }, [availableYears]);
  
  // Prepara le opzioni per le categorie
  useEffect(() => {
    if (availableCategorie) {
      setCategoriaOptions(getCategoriaFilters(availableCategorie));
    }
  }, [availableCategorie]);

  // Gestisce il cambio del termine di ricerca
  const handleSearchChange = (e) => {
    const term = e.target.value;
    onSearch(term);
  };
  
  // Gestisce il cambio dell'anno
  const handleYearChange = (option) => {
    onYearChange(option.value);
  };
  
  // Gestisce il cambio del mese
  const handleMonthChange = (option) => {
    onMonthChange(option.value);
  };
  
  // Gestisce il cambio della categoria
  const handleCategoriaChange = (option) => {
    onCategoriaChange(option.value);
  };
  
  // Trova le opzioni correnti selezionate
  const currentYearOption = yearOptions.find(option => option.value === selectedYear) || yearOptions[0];
  const currentMonthOption = monthFilters.find(option => option.value === selectedMonth) || monthFilters[0];
  const currentCategoriaOption = categoriaOptions.find(option => option.value === selectedCategoria) || categoriaOptions[0];

  return (
    <div className="analitica-filter">
      <div className="filters-container">
        <input
          type="text"
          onChange={handleSearchChange}
          placeholder="Cerca per settore, progetto o cliente..."
          className="search-bar"
          value={searchTerm}
        />

        <div className="dropdown-filters">
          <Select
            className="filter-select"
            options={yearOptions}
            onChange={handleYearChange}
            value={currentYearOption}
            placeholder="Seleziona anno"
            isSearchable={false}
          />
          <Select
            className="filter-select"
            options={monthFilters}
            onChange={handleMonthChange}
            value={currentMonthOption}
            placeholder="Seleziona mese"
            isSearchable={false}
          />
          <Select
            className="filter-select"
            options={categoriaOptions}
            onChange={handleCategoriaChange}
            value={currentCategoriaOption}
            placeholder="Seleziona categoria"
            isSearchable={false}
          />
        </div>
      </div>
    </div>
  );
}